/* KatSpout → checkout.katspout.nl handoff.
   Every checkout click leaves Shopify with the live cart and lands on the hosted
   checkout (Mollie iDEAL + Bancontact through the janisdev bridge).
   Shopify's own checkout and the accelerated wallet buttons are never used. */
(function () {
  var PAY = 'https://checkout.katspout.nl/pay/';
  var ATTR_KEYS = ['aff', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ttclid', 'fbclid', 'gclid'];
  var busy = false;

  function snapshot() {
    try {
      var q = new URLSearchParams(location.search), got = {};
      ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) got[k] = String(v).slice(0, 120); });
      if (Object.keys(got).length && !sessionStorage.getItem('ks_attr0')) {
        sessionStorage.setItem('ks_attr0', JSON.stringify(got));
      }
    } catch (e) {}
  }

  function attrQuery() {
    var out = {};
    try { out = JSON.parse(sessionStorage.getItem('ks_attr0') || '{}') || {}; } catch (e) {}
    try {
      var q = new URLSearchParams(location.search);
      ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) out[k] = String(v).slice(0, 120); });
    } catch (e) {}
    var parts = [];
    Object.keys(out).forEach(function (k) { parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(out[k])); });
    try { var dc = localStorage.getItem('ks_discount'); if (dc && /^[A-Z0-9]{3,12}$/.test(dc)) parts.push('code=' + encodeURIComponent(dc)); } catch (e) {} // ks-discount
    return parts.length ? '&' + parts.join('&') : '';
  }

  function b64url(obj) {
    var b = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    return b.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function lineTitle(i) {
    var t = i.product_title || i.title || '';
    if (i.variant_title && i.variant_title !== 'Default Title') t += ' — ' + i.variant_title;
    return t;
  }

  function imgOf(i) {
    var u = i.image || (i.featured_image && i.featured_image.url) || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }

  /* The hosted checkout is on a different host. If it is unreachable (DNS not yet live,
     box down) fall back to Shopify's own checkout instead of dumping the buyer on a
     browser error page. Result is cached for the tab. */
  function reachable() {
    try { if (sessionStorage.getItem('ks_pay_up') === '1') return Promise.resolve(true); } catch (e) {}
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 3000);
    return fetch(PAY + 'assets/ping.txt', { mode: 'no-cors', cache: 'no-store', signal: ctl && ctl.signal })
      .then(function () { clearTimeout(to); try { sessionStorage.setItem('ks_pay_up', '1'); } catch (e) {} return true; })
      .catch(function () { clearTimeout(to); return false; });
  }

  function handoff() {
    if (busy) return;
    busy = true;
    reachable().then(function (up) {
      if (!up) { location.href = '/checkout'; return; }
      return buildAndGo();
    });
  }

  function buildAndGo() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) { busy = false; location.href = '/cart'; return; }
        var cart = {
          cur: 'EUR',
          sym: '€',
          total: Math.round(c.total_price) / 100,
          items: c.items.map(function (i) {
            return {
              id: String(i.variant_id),
              q: i.quantity,
              title: lineTitle(i),
              line: Math.round(i.final_line_price) / 100,
              img: imgOf(i)
            };
          })
        };
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'InitiateCheckout', {
              value: cart.total,
              currency: 'EUR',
              num_items: cart.items.reduce(function (s, i) { return s + i.q; }, 0),
              content_type: 'product',
              content_ids: cart.items.map(function (i) { return i.id; })
            });
          }
        } catch (e) {}
        location.href = PAY + '?cart=' + b64url(cart) + attrQuery();
      })
      .catch(function () { busy = false; });
  }

  var SEL = '[name="checkout"],#checkout,.cart__checkout-button,a[href="/checkout"],a[href^="/checkout?"],a[href^="/cart/checkout"]';

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handoff();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f) return;
    var sub = e.submitter || document.activeElement;
    var isCheckout = sub && ((sub.name === 'checkout') || (sub.id === 'checkout') ||
      (sub.classList && sub.classList.contains('cart__checkout-button')));
    if (!isCheckout) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handoff();
  }, true);

  // Wallet / accelerated buttons bypass the handoff — they go straight to Shopify checkout.
  var css = '.shopify-payment-button,.additional-checkout-buttons,.accelerated-checkout-block,' +
    '#dynamic-checkout-cart,[data-shopify="dynamic-checkout-cart"],[data-shopify="payment-button"]' +
    '{display:none!important}';
  var st = document.createElement('style');
  st.setAttribute('data-katspout-pay', '1');
  st.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(st);

  /* ---- Meta pixel events the base snippet doesn't cover ----
     PageView comes from the inline snippet in theme.liquid; Purchase is server-side only
     (capi-sweep on the checkout box), so it is never double-fired from the browser. */
  function meta() { return typeof window.fbq === 'function' ? window.fbq : null; }

  function viewContent(tries) {
    var f = meta();
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if ((!f || !m) && (tries || 0) < 20) { setTimeout(function () { viewContent((tries || 0) + 1); }, 250); return; }
    if (!f || !m || !m.product || !m.page || m.page.pageType !== 'product') return;
    try {
      var v = (m.product.variants && m.product.variants[0]) || {};
      f('track', 'ViewContent', {
        content_type: 'product',
        content_ids: [String(v.id || m.product.id)],
        content_name: m.product.name || v.name || '',
        value: (v.price || 0) / 100,
        currency: 'EUR'
      });
    } catch (e) {}
  }

  // AddToCart: the theme adds through /cart/add(.js) with fetch — hook it rather than guess buttons.
  (function () {
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var out = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?/.test(url)) {
        out.then(function (r) {
          try {
            var f = meta();
            if (!f || !r || !r.ok) return;
            r.clone().json().then(function (d) {
              var items = (d && d.items) ? d.items : (d && d.id ? [d] : []);
              items.forEach(function (i) {
                f('track', 'AddToCart', {
                  content_type: 'product',
                  content_ids: [String(i.variant_id || i.id)],
                  content_name: i.product_title || i.title || '',
                  value: (i.final_line_price != null ? i.final_line_price : i.price || 0) / 100,
                  currency: 'EUR'
                });
              });
            }).catch(function () {});
          } catch (e) {}
        }).catch(function () {});
      }
      return out;
    };
  })();

  /* ---- Horizon's sticky add-to-cart and the chat launcher share the bottom-right corner.
     On mobile the launcher sat ON the buy button. Lift it while the bar is showing.
     nv-chat's shadow root is open, so the launcher is reachable. ---- */
  (function () {
    function launcher() {
      var host = document.getElementById('nv-chat-root');
      return host && host.shadowRoot ? host.shadowRoot.querySelector('.launcher') : null;
    }
    var ticking = false;
    function sync() {
      ticking = false;
      var l = launcher();
      if (!l) return;
      // <sticky-add-to-cart> is a zero-height wrapper; the bar that actually paints is a
      // fixed-position child, so measure the child (or its button), never the custom element.
      var bar = document.querySelector('sticky-add-to-cart, .lp-sticky');
      var lift = 0;
      if (bar) {
        var candidates = [bar].concat([].slice.call(bar.querySelectorAll('*')));
        for (var i = 0; i < candidates.length; i++) {
          var r = candidates[i].getBoundingClientRect();
          if (r.height > 24 && r.width > 120 && r.bottom > window.innerHeight - 8 && r.top < window.innerHeight) {
            lift = Math.max(lift, Math.round(window.innerHeight - r.top) + 12);
          }
        }
      }
      var want = lift ? 'calc(' + lift + 'px + env(safe-area-inset-bottom, 0px))' : '';
      if (l.style.bottom !== want) {
        l.style.bottom = want;
        l.style.transition = 'bottom .18s ease';
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }
    var tries = 0;
    (function wait() {
      if (launcher()) {
        sync();
        addEventListener('scroll', onScroll, { passive: true });
        addEventListener('resize', onScroll, { passive: true });
        var bar = document.querySelector('sticky-add-to-cart');
        if (bar && window.MutationObserver) new MutationObserver(sync).observe(bar, { attributes: true });
        setInterval(sync, 1200);   // the bar mounts/unmounts as the buy box scrolls past
        return;
      }
      if (++tries < 60) setTimeout(wait, 500);
    })();
  })();

  snapshot();
  viewContent(0);
})();
